import { render, staticRenderFns } from "./AltenteFreespins.vue?vue&type=template&id=b58122fa&"
import script from "./AltenteFreespins.vue?vue&type=script&lang=js&"
export * from "./AltenteFreespins.vue?vue&type=script&lang=js&"
import style0 from "./AltenteFreespins.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports